/**
 * CR431: Build a renderable deal from a raw DB row.
 * CR434: Uses mergeCanonicalDeal to guarantee id is never clobbered.
 * 
 * Merges canonical_deal_json into the row, normalizes ID, and tags provenance.
 * Use this whenever mapping raw view rows to deal objects for rendering.
 */

import { mergeCanonicalDeal } from "./mergeCanonicalDeal";
import { normalizeDealRecord } from "./normalizeDealRecord";
import { tagDealProvenance, type DealSurface } from "./dealViewRegistry";

export function buildRenderableDeal(row: any, surface: DealSurface) {
  const merged = mergeCanonicalDeal(row);
  const normalized = normalizeDealRecord(merged, surface);
  return tagDealProvenance(normalized, surface);
}
